import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Modal from "react-modal";
import Sidebar from "../components/Sidebar";

const SubmissionsPage = () => {
    const [submissions, setSubmissions] = useState([]);
    const [formFields, setFormFields] = useState([]);
    const [error, setError] = useState(null);
    const [selectedSubmission, setSelectedSubmission] = useState(null);
    const {eventId, tourName,tourId, eventName} = useParams();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    useEffect(() => {
        fetch(`${apiUrl}/submissions/${eventId}`)
            .then((res) => res.json())
            .then((data) => {
                setSubmissions(data.submissions || []);
                setFormFields(data.form ? Object.keys(data.form.fields).slice(0, 4) : []);
            })
            .catch((err) => setError("Error fetching submissions"));
    }, [apiUrl, eventId]);

    const formatCamelCase = (str) => {
        return str
            .replace(/_/g, " ") // Replace underscores with spaces
            .toLowerCase()
            .replace(/(?:^|\s)\S/g, (match) => match.toUpperCase()); // Capitalize the first letter of each word
    };
    const toProperCase = (text) => {
        if (!text) return text; // Handle empty or null input
        return text
            .split(" ") // Split the string into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" "); // Join the words back into a single string
    }

    const handleExport = () => {
        window.open(`${apiUrl}/submissions/export/${eventId}`);
    };

    const handleViewAll = (submission) => {
        setSelectedSubmission(submission);
    };

    const handleCloseModal = () => {
        setSelectedSubmission(null);
    };

    function formatDate(isoDate) {
        if (!isoDate) return "N/A";
        const date = new Date(isoDate);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    }

    const normalizedFormFields = formFields.map(field => toProperCase(field));
    const eventUrl = `/events/${tourId}/${tourName}`;
    return (
        <div className="dashboard">
            <Sidebar />
            <main className="main-content">
                <header className="header component">
                    <span className="component-header"> {eventName} Submissions</span>
                    {submissions.length > 0 && ( // Conditionally show Export button
                        <button className="btn btn-primary" onClick={handleExport}>
                            <i className="fa fa-download"></i> Export
                        </button>
                    )}
                </header>
                <p><a href="/dashboard"> Home </a> {'>'} <a href="/tours"> Tours </a> {'>'} <a href={eventUrl}> {tourName}</a> {'>'} {eventName}  </p>
                <hr/>
                <div>

                    {error && <p className="text-danger">{error}</p>}
                    <table className="table">
                        <thead>
                        <tr>
                            {formFields.map((field, index) => (
                                <th key={index}>{toProperCase(field)}</th>
                            ))}
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {submissions.map((submission, index) => (
                            <tr key={index}>
                                {normalizedFormFields.map((field, idx) => (
                                    <td key={idx}>
                                        {field.includes("Date") // Check if the field is a date
                                            ? formatDate(submission.data[field])
                                            : submission.data[field] || "N/A"}
                                    </td>
                                ))}
                                <td>
                                    <button
                                        className="btn btn-link"
                                        onClick={() => handleViewAll(submission)}
                                    >
                                        View All
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>


                    {/* Modal for viewing all details */}
                    <Modal
                        isOpen={!!selectedSubmission}
                        onRequestClose={handleCloseModal}
                        contentLabel="Submission Details"
                    >
                        <h4>Submission Details</h4>
                        {selectedSubmission && (
                            <ul>
                                {Object.entries(selectedSubmission.data).map(([key, value], index) => (
                                    <li key={index}>
                                        <strong>{formatCamelCase(key)}:</strong> {value}
                                    </li>
                                ))}
                            </ul>
                        )}
                        <button className="btn btn-secondary" onClick={handleCloseModal}>
                            Close
                        </button>
                    </Modal>
                </div>

            </main>

        </div>
    );
};

export default SubmissionsPage;